import React from "react";

function LampIcon(props) {
  return (
    <svg
      className={`icon-style  ${props.className || ""}`}
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      fill="#ccc"
      viewBox="0 0 32 32"
    >
      <path d="M17.747 14.017c-1.25.562-4.022-.815-4.022-.815-3.248-1.947 1.22 6.073 1.22 6.073s.093 2.503.655 2.815c4.687-6.563 3.397-8.636 2.147-8.073zM16.06 20.24c-.379 0-1.972-4.779-1.784-5.779 1.251.125 2.409.597 3.097.222 1.937-.878-.876 5.557-1.313 5.557zm3.892 3.707c.115-7.305 4.046-10.116 4.046-14.466 0-3.712-2.54-8.45-7.87-8.45-5.329 0-8.126 4.533-8.126 8.484 0 4.436 3.993 7.224 3.993 14.478h4.043s3.798-.046 3.914-.046zm-7.143-.927c0-6.771-3.868-9.373-3.868-13.513 0-3.688 2.51-7.556 7.173-7.556s6.948 4.06 6.948 7.524c0 4.06-3.814 6.742-3.916 13.56l-3.111-.016h-3.226zm6.696 1.994h-7a.5.5 0 000 1h7a.5.5 0 000-1zm0 2h-7a.5.5 0 000 1h7a.5.5 0 000-1zm-6.508 2.029v.9c0 .566.444 1.025.992 1.025h4.031c.549 0 .992-.459.992-1.025s-.062-.9-.062-.9h-5.953z"></path>
    </svg>
  );
}

export default LampIcon;
